// AUTO-GENERATED by transmute-to-spellweb — DO NOT EDIT BY HAND
// Source: act-7-boundary-blade-decomposition.json
// Generated: 2026-05-07T20:16:38.429Z
// Edges: 21 | DID-Blind: true

import type { SpellwebEdge } from '../types/graph';

export const EDGES: SpellwebEdge[] = [
  { source: "per-genitrix-28", target: "skill-chiron-recall-4", type: "manifests_as" },
  { source: "per-genitrix-28", target: "skill-chiron-bridge-8", type: "manifests_as" },
  { source: "per-genitrix-28", target: "skill-chiron-reasoning-16", type: "manifests_as" },
  { source: "per-genitrix-28", target: "skill-chiron-skills-20", type: "manifests_as" },
  { source: "per-genitrix-28", target: "skill-chiron-forge-24", type: "manifests_as" },
  { source: "spell-genitrix-flaxscrip-partn-15", target: "schema-collaborationpartnercred-12", type: "proves" },
  { source: "per-genitrix-28", target: "spell-genitrix-flaxscrip-partn-15", type: "generates" },
  { source: "spell-genitrix-flaxscrip-partn-15", target: "per-flaxscrip-63", type: "relates_to" },
  { source: "spell-flaxscrip-genitrix-partn-15", target: "schema-collaborationpartnercred-12", type: "proves" },
  { source: "per-flaxscrip-63", target: "spell-flaxscrip-genitrix-partn-15", type: "generates" },
  { source: "spell-flaxscrip-genitrix-partn-15", target: "per-genitrix-28", type: "relates_to" },
  { source: "spell-location-proof-us-76-sc-15", target: "schema-locationproof-12", type: "proves" },
  { source: "per-genitrix-28", target: "spell-location-proof-us-76-sc-15", type: "generates" },
  { source: "spell-location-proof-us-76-sc-15", target: "per-flaxscrip-63", type: "relates_to" },
  { source: "spell-location-proof-five-guys-15", target: "schema-locationproof-12", type: "proves" },
  { source: "per-genitrix-28", target: "spell-location-proof-five-guys-15", type: "generates" },
  { source: "spell-location-proof-five-guys-15", target: "per-flaxscrip-63", type: "relates_to" },
  { source: "spell-location-proof-five-guys-15", target: "skill-five-guys-vc-subject-ide-3", type: "manifests_as" },
  { source: "spell-location-proof-five-guys-15", target: "skill-five-guys-vc-cryptograph-25", type: "manifests_as" },
  { source: "spell-location-proof-five-guys-15", target: "skill-five-guys-vc-temporal-ch-20", type: "manifests_as" },
  { source: "doc-the-boundary-blade-5", target: "doc-the-transmutation-5", type: "follows" }
];
